import { api } from '../../../api/api';
import { DataUsageType } from './dataUsage/types';
import { SimInfoResponse, RouterInfoResponse, CameraResponse } from './types';

const CAMERAS_TAG = 'cameras';

export const camerasApi = api.enhanceEndpoints({ addTagTypes: [CAMERAS_TAG] }).injectEndpoints({
  endpoints: (build) => ({
    getCameras: build.query<CameraResponse, void>({
      query: () => ({
        method: 'GET',
        url: 'cameras/plansV2'
      }),
      providesTags: [CAMERAS_TAG]
    }),
    getCameraSimInfo: build.query<SimInfoResponse, { iccid: string }>({
      query: ({ iccid }) => ({
        method: 'GET',
        url: `cameras/sim-info/${iccid}`
      })
    }),
    getCameraRouterInfo: build.query<RouterInfoResponse, { iccid: string }>({
      query: ({ iccid }) => ({
        method: 'GET',
        url: `cameras/router-info/${iccid}`
      })
    }),
    getDataUsage: build.query<
      DataUsageType,
      { iccid: string; month?: string }
    >({
      query: ({ iccid, month }) => ({
        method: 'GET',
        url: `data-usage/${iccid}`,
        params: { month }
      })
    }),
    getCombinedDataUsage: build.query<
      DataUsageType,
      { month?: string } | void
    >({
      query: (args) => ({
        method: 'GET',
        url: 'data-usage/combined',
        params: args ? { month: args.month } : undefined
      })
    }),
    updateCameraName: build.mutation<void, { iccid: string; name: string }>({
      query: ({ iccid, name }) => ({
        method: 'POST',
        url: `cameras/update-nickname`,
        body: {
          simIccid: iccid,
          nickname: name
        }
      }),
      invalidatesTags: [CAMERAS_TAG]
    })
  })
});

export const {
  useGetCamerasQuery,
  useGetCameraSimInfoQuery,
  useGetCameraRouterInfoQuery,
  useGetDataUsageQuery,
  useGetCombinedDataUsageQuery,
  useUpdateCameraNameMutation
} = camerasApi;
